/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import QueryStringNavigate from '../QueryStringNavigate';

import * as S from './Breadcrumb.styled';
import { BreadcumbSeparator } from '../Icons';

const BreadcrumbItem = ({ label, href, isCurrent, itemClassName }) => (
  <S.Item css={isCurrent && { overflow: 'hidden' }}>
    {!isCurrent && (
      <>
        <QueryStringNavigate className={itemClassName} path={href}>
          {label}
        </QueryStringNavigate>
        <BreadcumbSeparator />
      </>
    )}
    {isCurrent && <span title={label}>{label}</span>}
  </S.Item>
);

const Breadcrumb = ({ list, itemClassName, containerClassName, ...rest }) => (
  <S.Container {...rest} data-cy="wpBreadcrumb" className={containerClassName}>
    <S.Layout>
      {list.map(({ label, href }, index) => (
        <BreadcrumbItem
          key={label}
          label={label}
          href={href}
          isCurrent={list.length <= index + 1}
          itemClassName={itemClassName}
        />
      ))}
    </S.Layout>
  </S.Container>
);

Breadcrumb.displayName = 'Breadcrumb';
export default Breadcrumb;
